import BannerText from "./BannerText";

const DEFAULT_BACKGROUND_SIZE = "contain";
const DEFAULT_BACKGROUND_POSITION = "right center";

export const createBannerText = (config: {
  pageName: string;
  headingItalic: string;
  headingBold: string;
  descriptionDesktop: string;
  descriptionMobile: string;
  backgroundImage?: string;
  backgroundSize?: string;
  backgroundPosition?: string;
}): BannerText => {
  const result: BannerText = {
    pageName: config.pageName,
    headingItalic: config.headingItalic,
    headingBold: config.headingBold,
    descriptionDesktop: config.descriptionDesktop,
    descriptionMobile: config.descriptionMobile,
  };

  if (config.backgroundImage) {
    result.backgroundImage = config.backgroundImage;
    result.backgroundSize = config.backgroundSize || DEFAULT_BACKGROUND_SIZE;
    result.backgroundPosition = config.backgroundPosition || DEFAULT_BACKGROUND_POSITION;
  }

  return result;
};
